import React from "react";
import {List, ListItem, ListItemIcon, ListItemText, Typography} from "@mui/material";
import {Icon} from "@iconify/react";
import {resetUser} from "../../app/features/userSlice";
import {resetAuth} from "../../app/features/Auth";
import {RoutesList} from "../../Modules/RoutesList";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";

export const Logout = () =>{

    const navigator = useNavigate()
    const dispatch = useDispatch()

    const handleLogout = () =>{
        localStorage.clear()
        dispatch(resetUser())
        dispatch(resetAuth())
        navigator(RoutesList.Login.path)
    }

    return(
        <List className="logout-button">
            <div
                onClick={handleLogout}
                style={{
                    textDecoration:"none",
                    color: "#089BAB",
                    cursor:"pointer"
                }}
            >
                <ListItem>
                    <ListItemIcon
                        style={{
                            color:"#0096C7",
                            fontSize: "32px",
                            justifyContent:"end"
                        }}
                    >
                        <Icon icon="majesticons:logout-half-circle" rotate={2} />
                    </ListItemIcon>
                    <ListItemText primary={"Logout"}
                                  disableTypography
                                  style={{
                                      letterSpacing:"0.5px",
                                      fontWeight: "700",
                                      fontSize:"24px",
                                      marginLeft:10
                                  }}
                    />
                </ListItem>
            </div>
            <Typography sx={{textAlign:"center",marginLeft:"50px"}} color={"#8F95B2"}>
                v5.0.0
            </Typography>
        </List>
    )
}